module.exports = __webpack_public_path__ + "static/media/icon-x.0cdf8918.svg";